import styled from "styled-components";
import {
  basicColor,
  fontFamilyMedium,
  lightDark3,
  primaryColor,
  pureDark,
  pureDark2,
  tertiaryGrey12,
  tertiaryGrey8,
  whiteColor,
} from "../../components/GlobalStyle";

export const LoginStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${tertiaryGrey8};
  margin: 0 auto;
  margin-bottom: 16px;

  p {
    margin-bottom: 0px;
  }
  .remember-me {
    font-size: 16px;
  }

  .login-container {
    .line {
      height: 10px;
      width: 100%;
    }
    .or-line {
      margin-top: 20px;
    }
    &-card {
      max-width: 485px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: white;
      border-radius: 6px;
      width: 100%;
      margin: auto;
      padding: 20px 12px;
      background-color: ${whiteColor};
      &-form {
        width: 96%;
        .login-input-fields {
          &-field {
            margin-top: 20px;
          }
        }
      }
      .title {
        color: ${pureDark2};
        font-size: 22px;
        font-family: ${fontFamilyMedium};
      }
      .login-text {
        font-size: 16px;
        color: ${lightDark3};
        margin-top: 12px;
      }

      &-logo {
        text-align: center;

        img {
          width: 164px;
          margin-bottom: 0;
        }

        h1 {
          font-size: 20px;
          font-weight: 700;
          color: #1b283f;
        }
      }
    }
    .terms-conditions {
      max-width: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .signup-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    a {
      color: ${primaryColor};
      font-size: 16px;
    }
    p {
      color: ${pureDark};
    }
    h6 {
      font-size: 16px;
      font-weight: normal;
      color: ${basicColor};
    }
  }
  .is-invalid {
    border: 1px solid red;
    background: white;
    border-radius: 8px;
    padding: 10px;
    width: 100%;
    width: -moz-available;
    outline: none;
    margin-bottom: 8px;
  }
  .customInput,
  .customPasswordInput {
    background: white;
    border: 1px solid #c6c6c8;
    border-radius: 2px;
    padding: 10px;
    width: 100%;
    width: -moz-available;
    outline: none;
    margin-bottom: 8px;
  }
  .forget_password {
    color: ${primaryColor};
    font-size: 16px;
    text-decoration: none;
    font-family: "EnnVisionsMedium" !important;
  }
  .remember-password {
    &-text {
      color: ${tertiaryGrey12};
    }
  }
  .ant-input-suffix {
    margin-left: 30px;
  }
  .logo {
    height: 60px;
    width: 155px;
    margin-bottom: 20px;
  }
  .line {
    display: none;
  }

  @media screen and (max-width: 425px) {
    .login-container {
      &-card {
        padding: 3px;
        &-logo {
          h1 {
            display: none;
          }
        }
      }
    }
    .signup-text {
      p {
        font-size: 16px;
      }
      h6 {
        font-size: 16px;
        margin-left: 3px;
      }
    }
    .line {
      display: inline;
      width: 90%;
      margin-bottom: 6px;
    }
  }
`;

export default LoginStyle;
